import { BankSlipModel } from '../models/bankslip.model';
import { Injectable } from '@angular/core';
import { RechargeModel } from '../models/recharge.model';
import { AppService } from '../app.service';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class RechargeService extends AppService<RechargeModel> {

  constructor(http: HttpClient) {
    super(http);
  }

  async recharge(
    CartaoUsuarioMeepId: string,
    CodigoSeguranca: string,
    CartaoCashlessId: string,
    HistoricoAssociacaoId: string,
    Valor: number,
    Fingerprint: string) {
    const result = await this.postAsync(`Pagamento/RecarregarCartaoCashlessOnline`,
    {
      CartaoUsuarioMeepId,
      HistoricoAssociacaoId,
      CodigoSeguranca,
      CartaoCashlessId,
      Valor,
      Fingerprint
    });
    return result;
  }

  async rechargeWithBankSlip(recharge: BankSlipModel) {
    const result = await this.postAsync(`Pagamento/GerarBoletoParaRecarga`, recharge);
    return result;
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/services/recharge.service.ts